var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('div',{staticClass:"time-item",class:{ mobile: _vm.mobile }},[_c('p',[_vm._v("00h :")]),_c('p',[_vm._v(_vm._s(_vm.minutes)+"m :")]),_c('p',[_vm._v(_vm._s(_vm.seconds)+"s")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }